module.exports = __webpack_public_path__ + "media/抽噎声.417188c5.wav";